import { v4 as uuidv4 } from 'uuid';
import _ from 'lodash';
import { chartTemplate } from './constants';

/**
 * Create new chart object from template
 * @param {Array} charts - Current array of chart objects
 * @param {string} [uuid] - Optional uuid. This will be used if passed in.
 * @returns {Object} - New chart object
 */
const getNewChart = (charts, uuid = null) => {
  let newUUID = uuid;
  if (newUUID === null) {
    newUUID = uuidv4();
  }
  /** Deep copy from the chart template */
  const newChart = _.defaultsDeep({}, chartTemplate);
  newChart.i = newUUID;
  newChart.chart.uuid = newUUID;
  if (charts.length > 0) {
    if (charts.length % 2 !== 0) {
      newChart.x = 6;
    }
  }
  return newChart;
};

export default getNewChart;
